import { token, user, assetsLimits, workspacePlan } from './user.state.svelte.js';
import API from '../../services/api.svelte.js';
import { notificate } from '../../services/notification.js';
import workspaceService from '../../services/workspace.js';
import { format, locale } from 'svelte-i18n';
import { get as getStore } from 'svelte/store';


let access_token = $derived(token.access_token);


// store user/me promise to avoid multiple simultaneous API calls
let userMePromise;


export function login(username, captcha_token, next_page) {
    let data = new FormData();
    data.append('username', username);

    return otac_generate(username, false, captcha_token, next_page ? next_page : null)
        .catch(e => {
            throw new Error(e);
        })
        .then(response => {
            if (response != "ok") {
                if(response.status != 401){
                    if(response.status == 403){
                        return logout(true)
                    }
                    notificate(`${response.status}`, "toast");
                }
                throw new Error(response);
            }
            return response;
        })
    ;
}


export async function otac_generate(email, create_workspace, captcha_token, next_page) {
    let params = {email: email, create_workspace: create_workspace, captcha_token: captcha_token};
    if(next_page) params.ui_page_to_visit = next_page;
    return fetch(API.url + '/otac/', {
            method : "POST",
            body   : JSON.stringify(params),
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(data => {
                    if(data.detail){
                        let e = data.detail.split(",");

                        e.forEach(string=>{
                            if(string == "Invalid CAPTCHA"){
                                // api validation errors
                                let toastConfig = {
                                    data: "",
                                    options : {
                                        "timeOut": "0",
                                        "extendedTimeOut": "0",
                                        "showDuration": "0",
                                        "hideDuration": "0",
                                        "closeButton": true
                                    }
                                }
                                notificate("invalid_captcha", "toast", toastConfig);
                            }
                            if(string == 'email_recently_used'){
                                // api validation errors
                                let toastConfig = {
                                    data: data.email,
                                    options : {
                                        "timeOut": "0",
                                        "extendedTimeOut": "0",
                                        "showDuration": "0",
                                        "hideDuration": "0",
                                        "closeButton": true
                                    }
                                }
                                notificate("email_recently_used", "toast", toastConfig);
                            }
                            if(string == 'ip_address_recently_used'){
                                // api validation errors
                                let toastConfig = {
                                    data: data.email,
                                    options : {
                                        "timeOut": "0",
                                        "extendedTimeOut": "0",
                                        "showDuration": "0",
                                        "hideDuration": "0",
                                        "closeButton": true
                                    }
                                }
                                notificate("ip_address_recently_used", "toast", toastConfig);
                            }
                        })
                    }
                    throw new Error(response);

                });
            }
            return response.json();
        })
    ;
}

export function otac_validate(pOTAC) {
    return fetch(API.url + '/otac/validate', {
            method : "POST",
            body   : JSON.stringify({otac:pOTAC}),
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        .then(response => {
            if (!response.ok) {
                notificate(`${response.status}`);
                return response.json().then(data => { throw new Error(data.detail) })
            }
            return response.json();
        })
        .then(data => {
            token.access_token = data.access_token;
            return getLoggedUser();
        })
    ;
}

export function login_token(pToken) {
    return fetch(API.url + '/user/login/token', {
            method : "POST",
            body   : JSON.stringify({token:pToken}),
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        .then(response => {
            if (!response.ok) {
                notificate(`${response.status}`);
                throw new Error(response);
            }

            return response.json();
        })
        .then(data => {
            token.access_token = data.access_token;
            return getLoggedUser();
        })
    ;
}

export const logout = (workspace_suspended = false, loginPath = '/login') => {
    return fetch(API.url + '/user/logout', {
        method : "POST",
        headers: {
            Authorization : 'Bearer ' + access_token,
        }

    })
    .catch(e => {
        notificate('network_error');
        throw new Error(e);
    })
    .then(()=>{
        token.access_token = null;
        assetsLimits.data = {};
        location.href = !workspace_suspended ? loginPath : '/login?workspace=suspended';
    });
}

export function getLoggedUser() {
    // global variable reactive to token store
    if (!access_token) {
        return Promise.resolve(null);
    }

    userMePromise = fetch(API.url + '/user/me', {
            headers: {
                Authorization : 'Bearer ' + access_token,
            }
        })
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        .then(async response => {
            if (!response.ok) {
                notificate(`${response.status}`);
                throw new Error(response);
            }
            let loggedUserResponse = await response.json();
            locale.set(loggedUserResponse.language);
            return loggedUserResponse;
        })
        .then(async data => {
            let settings      = await getLoggedUserSettings();
            let workspaceData = await workspaceService.search();
            if(workspaceData.status === 'suspended') {
                return logout(true);
            }
            Object.entries(settings).forEach(([key, value]) => {
                if(settings.length){
                    if(value["value"] == "True"  || value == "true") value["value"] = true;
                    if(value["value"] == "False" || value == "false") value["value"] = false;

                    data[value["key"]] = value["value"];
                }
                else {
                    if(value == "True" || value == "true") value = true;
                    if(value == "False" || value == "false") value = false;
                    data[key] = value;
                }
            });

            if(!data.show_welcome_msg && data.show_welcome_msg != false) data.show_welcome_msg = true;
            if(!data.terms_and_conditions_accepted) data.terms_and_conditions_accepted = false;
            if(data.email.includes('@securetia.com')) {
                data.is_internal = true;
            } else {
                data.is_internal = false;
            }

            user.data = data;

            workspacePlan.data = workspaceData.plan;

            assetsLimits.data = {
                active_directory_limit: workspaceData.active_directory_limit,
                cloud_limit: workspaceData.cloud_limit,
                domain_limit: workspaceData.domain_limit,
                email_limit: workspaceData.email_limit,
                endpoint_limit: workspaceData.endpoint_limit,
                ip_limit: workspaceData.ip_limit,
                network_limit: workspaceData.network_limit,
                private_network_limit: workspaceData.private_network_limit,
                private_ip_limit: workspaceData.private_ip_limit,
                source_code_limit: workspaceData.source_code_limit
            };
            return data;
        })
    ;
    return userMePromise;
}

export function search(config = {}) {
    return API.search('user/', config);
}

export function find(id, config = {}) {
    return API.find('user', id);
}

export function save(data, files = [], config = {}) {
    return API.save('user', data, files, config, false)
        .then(async (response) => {
            if (!response.ok) {
                // api validation errors
                let toastConfig = {
                    data: data.email,
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                notificate('save_error', "toast", toastConfig);
                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            return apiData;
        })
    ;
}

export function patchOwnUSer(data) {
    return API.patchOwnUSer(data)
        .then(async (response) => {
            if (!response.ok) {
                // api validation errors
                let toastConfig = {
                    data: data.email,
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                notificate('save_error', "toast", toastConfig);
                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            notificate('save_ok', "toast", {data: apiData.email});
            apiData.type = 'user';
            return apiData;
        })
    ;
}


export function del(user, config = {}) {
    return API.del('user', user.id, config)
        .then(async (response) => {
            if (!response.ok) {
                // api validation errors
                if(response.status == 403){
                    let toastConfig = {
                        options : {
                            "timeOut": "0",
                            "extendedTimeOut": "0",
                            "showDuration": "0",
                            "hideDuration": "0",
                            "closeButton": true
                        }
                    }
                    notificate("delete_own_user_error", "toast", toastConfig);
                } else {
                    notificate('delete_error', "toast", {data: user.email});
                }
                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(data => {
            notificate('delete_ok', "toast", {data: user.email});

            return data;
        })
    ;
}

export function getLoggedUserSettings(){
    let userSettingsPromise;

    userSettingsPromise = fetch(API.url + '/user/me/setting', {
        headers: {
                Authorization : 'Bearer ' + access_token,
            }
        })
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        .then(response => {
            if (!response.ok) {
                notificate(`${response.status}`);
                throw new Error(response);
            }
            return response.json();
        })
        .then(async data => {
            if(data.length == 0) data = {show_welcome_msg: true, terms_and_conditions_accepted: false};
            return data;
        })
    ;
    return userSettingsPromise;
}

export function saveLoggedUserSettings(data, files = [], config = {}) {
    return API.save('user/me/setting', data, files, config)
        .then(async (response) => {
            if (!response.ok) {
                if(!config.no_toaster){
                    // api validation errors
                    let toastConfig = {
                    data: data,
                        options : {
                            "timeOut": "0",
                            "extendedTimeOut": "0",
                            "showDuration": "0",
                            "hideDuration": "0",
                            "closeButton": true
                        }
                    }
                    notificate('save_error', "toast", toastConfig);
                }

                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            if(!config.no_toaster) notificate('save_ok', "toast", {data: apiData});
            apiData.type = 'user';
            return apiData;
        })
    ;
}

export function clearUserCache(){
    userMePromise = null;
}

export let roles = {
    administrator : 'Administrador',
    operator      : 'Operador',
    viewer        : 'Veedor',
    uploader      : "Uploader"
};

export let lang = {
    edit   : "Editar",
    save   : "Guardar",
    cancel : "Cancelar",
}

export async function can(module, action) {
    if (!module || !action) return false;
    let loggedUser = $state.snapshot(user.data);

    if (!loggedUser.role) return false;

    // everything
    if (loggedUser.role == "administrator") {
        return true;
    }

    // everything but edit users
    if (loggedUser.role == "operator") {
        if (module == "user" && ["add", "edit", "delete"].includes(action)) {
            return false;
        }
        return true;
    }

    // read only
    if (loggedUser.role == "viewer") {
        if (["add", "edit", "delete"].includes(action)) {
            return false;
        }
        return true;
    }

    return false;
}

export function is_internal() {
    if(user.data.email.includes("@securetia.com")){
        return true;
    }
    else {
        return false;
    }

}

// components/inline-edit definitions
export let inlineEdit = {
    email : {
        type        : 'text',
        lang        : lang,
        placeholder : 'Agregar email',
    },
    role : {
        type        : 'select',
        lang        : lang,
        placeholder : 'Agregar rol',
        options     : Object.entries(roles).map(([key, value]) => ({value: key, label: value})),
    },
}

export function getLangOptions(lang){
    locale.set(lang)
    const languages = [
        { code: 'en', name: getStore(format)("english") },
        { code: 'es', name: getStore(format)("spanish") }
    ];
    return languages;
}



export default {
    login,
    login_token,
    otac_generate,
    otac_validate,
    logout,
    getLoggedUser,
    getLoggedUserSettings,
    saveLoggedUserSettings,
    search,
    find,
    save,
    del,
    can,
    roles,
    lang,
    inlineEdit,
    clearUserCache,
    is_internal,
    patchOwnUSer,
    getLangOptions
}
